import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Cookies from 'js-cookie'
import BaiduMap from 'vue-baidu-map'
import config from '../config'
import VueCookie from 'vue-cookie'

Vue.use(Element, {
  size: Cookies.get('size') || 'medium'
})
Vue.use(BaiduMap, {
  ak: 'DeNOFoYTiTHlaMGFW5XnvfknM0SWf1HG'
})
Vue.use(VueCookie)

Vue.config.productionTip = false
Vue.prototype.$config = config

function getURLParameter (name) {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}

window.isMiniProgram = !getURLParameter('isMiniProgram')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
